<template>
  <section>
    <el-row class="info-block">
      <p>Вы можете записать на погрузку по телефону</p>
      <el-link type="primary" href="tel:+79384444420">+7 938 444-44-20</el-link>
      <p>Звонок бесплатный</p>
      <p class="priority">
        Приоритет при записи будет отдаваться<br />
        перевозчикам подавшим заявку через<br />
        приложение
      </p>
    </el-row>
    <el-card class="choosed">
      <p>ВЫБЕРИТЕ ДАТУ ПОГРУЗКИ</p>
      <el-select v-model="choosed_day" placeholder="Выберите дату">
        <el-option
          v-for="(ld, i) in days"
          :key="ld.id"
          :label="ld.load_date"
          :value="i"
        >
          {{ ld.load_date }}
          <span v-if="ld.status === 1" style="color: #ff0000"> (закрыт)</span>
        </el-option>
      </el-select>
      <div class="btn_block">
        <el-button type="info" plain @click="$emit('back')">Отмена</el-button>
        <el-button
          v-if="choosed_day !== null"
          type="success"
          @click="$emit('next', true, choosed_day)"
        >
          Далее
        </el-button>
      </div>
    </el-card>
  </section>
</template>

<script>
export default {
  name: 'ChooseDayMobile',
  props: {
    days: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      choosed_day: null,
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
}
</script>
